export default __webpack_public_path__ + "static/media/1494.d0900b49.png";